import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import ApiService from "../../../ApiService";
import DispatchProps from "../../../../utils/DispatchProps";
import PageTitle from "../../../PageTitle";
import { IRootState } from "../../../../store";
import { Checkbox, MessageBarType, PrimaryButton } from 'office-ui-fabric-react';
import { UserAccessLevel } from '../../../../models/UserAccessRecord';
import Actions from '../../../../redux/Actions';
import { TenantRollover } from '../../../../models/rollover/TenantRollover';
import LoadingCard from '../../../LoadingCard';
import { TenantRolloverState } from '../../../../models/rollover/TenantRolloverState';
import BoolPill from '../../../BoolPill';
import Table, { TableColumn } from '../../../Table';
import TableCell from '../../../TableCell';
import { Link } from 'react-router-dom';
import { SchoolRolloverState } from "../../../../models/rollover/SchoolRolloverState";
import DurableFunctionInstanceStatus from "../../../DurableFunctionInstanceStatus";
import { SchoolRolloverEvent } from '../../../../models/rollover/SchoolRolloverEvent';
import { MailroomSchoolConfig } from "../../../../models/MailroomSchoolConfig";
import TimeTrafficCellContent from '../../../TimeTrafficCellContent';

// TODO: get from server
export const TARGET_ROLLOVER_YEAR = "2026";
export const TARGET_ROLLOVER_SDS_END_DATE_YEAR = "2027";
export const PREVIOUS_ROLLOVER_PROFILE_NAME = "CDB-2025";

interface TenantRolloverPageProps {
    apiService: ApiService;
    tenantId: string;
    usersAccessLevel?: UserAccessLevel,
}

interface TenantRolloverPageState {
    tenantRollover?: TenantRollover;
    loadingTenantRollover: boolean;

    tenantRolloverState?: TenantRolloverState;
    loadingTenantRolloverState: boolean;

    schoolRolloverEvents?: SchoolRolloverEvent[];
    loadingSchoolRolloverEvents: boolean;

    latestAcademicYearsInInbox?: { [key: string]: string }
    loadingLatestAcademicYearsInInbox: boolean;

    approveUpdateLoading: boolean;
    startUploadLoading: boolean;
    loadingToggleStudentMemberships: boolean;
}

class TenantRolloverPage extends Component<TenantRolloverPageProps & DispatchProps, TenantRolloverPageState> {
    static displayName = TenantRolloverPage.name;

    constructor(props: TenantRolloverPageProps & DispatchProps) {
        super(props);

        this.state = {
            loadingTenantRollover: true,
            loadingTenantRolloverState: true,
            loadingSchoolRolloverEvents: true,
            loadingLatestAcademicYearsInInbox: true,
            approveUpdateLoading: false,
            startUploadLoading: false,
            loadingToggleStudentMemberships: false
        }
    }

    private static readonly schoolColumns: TableColumn[] = [
        { title: "School", propertyPath: "school", enableSort: true, flex: 4 },
        { title: "Form Info", propertyPath: "rolloverForm", enableSort: false, flex: 6 },
        { title: "Academic Year In Inbox", propertyPath: "inbox", enableSort: true, flex: 3 },
        { title: "Rollover Steps", propertyPath: "rolloverSteps", enableSort: true, flex: 6 },
        { title: "Ready", propertyPath: "ready", enableSort: false, flex: 1 },
        { title: "Rollover Steps (Admin)", propertyPath: "rolloverStepsAdmin", enableSort: false, flex: 6 },
        { title: "Status", propertyPath: "status", enableSort: false, flex: 3 },
    ];

    private static readonly schoolRolloverEventsColumns: TableColumn[] = [
        { title: "School", propertyPath: "schoolCode", enableSort: false, flex: 1 },
        { title: "Event", propertyPath: "eventType", enableSort: false, flex: 1 },
        { title: "User ID", propertyPath: "userOid", enableSort: false, flex: 1 },
        { title: "Date", propertyPath: "dateTime", type: "date", enableSort: false, flex: 1 },
        { title: "Workload", propertyPath: "workloadId", enableSort: false, flex: 1 },
    ];

    async componentDidMount() {
        await this.loadRollover();
        await this.loadRolloverState();
        await this.loadSchoolRolloverEvents();
        await this.loadLatestAcademicYearsInInbox();
    }

    async componentDidUpdate(prevProps: Readonly<TenantRolloverPageProps & DispatchProps>, prevState: TenantRolloverPageState): Promise<void> {

    }

    async loadRollover() {
        this.setState({ loadingTenantRollover: true });

        try {
            const tenantRollover = await this.props.apiService.getRolloverForTenant(this.props.tenantId);
            this.setState({
                tenantRollover
            });
        }
        catch (e) {
            this.props.dispatch(Actions.showMessageBar(`Error loading tenant rollover. ${e.message}`, MessageBarType.error));
        }

        this.setState({ loadingTenantRollover: false });
    }

    async loadLatestAcademicYearsInInbox() {
        this.setState({ loadingLatestAcademicYearsInInbox: true });

        try {
            const latestAcademicYearsInInbox = await this.props.apiService.getLatestAcademicYearsInInboxForTenant(this.props.tenantId);
            this.setState({
                latestAcademicYearsInInbox
            });
        }
        catch (e) {
            this.props.dispatch(Actions.showMessageBar(`Error loading latest academic years in inbox. ${e.message}`, MessageBarType.error));
        }

        this.setState({ loadingLatestAcademicYearsInInbox: false });
    }

    async loadRolloverState() {
        this.setState({ loadingTenantRolloverState: true });

        try {
            const tenantRolloverState = await this.props.apiService.getRolloverStateForTenant(this.props.tenantId);
            this.setState({
                tenantRolloverState
            });
        }
        catch (e) {
            this.props.dispatch(Actions.showMessageBar(`Error loading tenant rollover. ${e.message}`, MessageBarType.error));
        }

        this.setState({ loadingTenantRolloverState: false });
    }

    async loadSchoolRolloverEvents() {
        this.setState({ loadingSchoolRolloverEvents: true });

        try {
            const schoolRolloverEvents = await this.props.apiService.getSchoolRolloverEvents(this.props.tenantId);
            this.setState({
                schoolRolloverEvents
            });
        }
        catch (e) {
            this.props.dispatch(Actions.showMessageBar(`Error loading school rollover events. ${e.message}`, MessageBarType.error));
        }

        this.setState({ loadingSchoolRolloverEvents: false });
    }

    private cellsForSchoolTable = (item: SchoolRolloverState, column: TableColumn, index: number): JSX.Element | undefined => {
        switch (column.propertyPath) {
            case "school":
                return <TableCell key={index} flex={column.flex}>
                    <Link to={`/cdb-admin/mailroom/${this.props.tenantId}/${item.schoolCode}`} target="_blank">
                        {item.schoolName}
                    </Link>
                    <span className="cdb-table__extra-detail">{item.schoolCode}</span>
                </TableCell>;

            case "rolloverForm":
                return <TableCell key={index} flex={column.flex}>
                    {this.cellForRolloverForm(item)}
                    <Link to={`/cdb-admin/rollover/${this.props.tenantId}/${item.schoolCode}/form/${TARGET_ROLLOVER_YEAR}`} target="_blank">
                        <span className="cdb-table__extra-detail" style={{ textDecoration: "underline" }}>View Rollover Form</span>
                    </Link>
                </TableCell>;

            case "automation":
                return <TableCell key={index} flex={column.flex}>
                    <span>{item.automationName}</span>
                    <span className="cdb-table__extra-detail">{item.automationState}</span>
                </TableCell>;

            case "inbox":
                return <TableCell key={index} flex={column.flex}>
                    <span>{this.state.latestAcademicYearsInInbox ? this.state.latestAcademicYearsInInbox[item.schoolCode] : null}</span>
                    <Link className={"text-extra-detail"} to={`/cdb-admin/mailroom/salamander/${this.props.tenantId}/${item.schoolCode}/inbox`} target="_blank">Check inbox files</Link>
                </TableCell>

            case "rolloverSteps":
                return <TableCell key={index} flex={column.flex}>
                    <div className="flex-row cell-content-row">
                        <div className={"flex-column flex-item--flex-1"}>
                            Processor:
                        </div>
                        <div className={"flex-column flex-item--flex-2"}>
                            <PrimaryButton text="Start Processor Preview" onClick={() => this.previewProcessor(item)} />
                        </div>
                    </div>
                    <div className="flex-row cell-content-row">
                        <div className={"flex-column flex-item--flex-1"}>
                            Disconnect:
                        </div>
                        <div className={"flex-column flex-item--flex-2"}>
                            {this.workloadCell("Disconnect", item.eventSummary.disconnectWorkloadId, item.eventSummary.disconnectWorkloadStatus, false, () => this.startDisconnect(item.schoolCode))}
                        </div>
                    </div>
                    <div className="flex-row cell-content-row">
                        <div className={"flex-column flex-item--flex-1"}>
                            Archive:
                        </div>
                        <div className={"flex-column flex-item--flex-2"}>
                            {this.workloadCell("Archive", item.eventSummary.archiveWorkloadId, item.eventSummary.archiveWorkloadStatus, false, () => this.startArchive(item.schoolCode))}
                        </div>
                    </div>
                    <div className="flex-row cell-content-row">
                        <div className={"flex-column flex-item--flex-1"}>
                            Memberships:
                        </div>
                        <div className={"flex-column flex-item--flex-2"}>
                            {this.toggleStudentMembershipButton(item)}
                        </div>
                    </div>
                </TableCell>;

            case "ready":
                return <TableCell key={index} flex={column.flex}>
                    <span style={{ alignSelf: "center" }}>{this.readyCheckbox(item.schoolCode, item.eventSummary.isDisconnected, item.eventSummary.isReady)}</span>
                </TableCell>;

            case "rolloverStepsAdmin":
                return <TableCell key={index} flex={column.flex}>
                    <div className="flex-row cell-content-row">
                        <div className={"flex-column flex-item--flex-1"}>
                            Configurations:
                        </div>
                        <div className={"flex-column flex-item--flex-2"}>
                            <PrimaryButton disabled={this.state.approveUpdateLoading} text="Approve and Update" onClick={async () => await this.approveUpdateRollover(this.props.tenantId, item.schoolCode)} />
                        </div>
                    </div>
                    <div className="flex-row cell-content-row">
                        <div className={"flex-column flex-item--flex-1"}>
                            Upload:
                        </div>
                        <div className={"flex-column flex-item--flex-2"}>
                            <PrimaryButton disabled={this.state.startUploadLoading} text="Start Upload" onClick={async () => await this.startUpload(this.props.tenantId, item.schoolCode)} />
                        </div>
                    </div>
                </TableCell>;

            case "status":
                return <TableCell key={index} flex={column.flex}>
                    <BoolPill trueText="Rolled Over" falseText="Awaiting Roll Over" value={item.isRolledOver} falseColour="amber" />
                </TableCell>;

        }
    }

    private cellsForSchoolRolloverEventTable = (item: SchoolRolloverEvent, column: TableColumn, index: number): JSX.Element | undefined => {
        switch (column.propertyPath) {
            case "workloadId":
                return <TableCell key={index} flex={column.flex}>
                    {this.GetWorkloadLink(item.workloadId)}
                </TableCell>;
        }
    }

    private GetWorkloadLink(workloadId?: string) {
        if (workloadId != undefined) {
            return <Link to={`/cdb-admin/workloads/${workloadId}`} target="_blank">
                Workload
            </Link>
        }
    }

    private cellForRolloverForm(item: SchoolRolloverState) {

        const schoolRollover = this.state.tenantRollover?.schools.find(sr => sr.schoolCode === item.schoolCode);
        if (schoolRollover == undefined) {
            return <i className="cell-content-row">No rollover data</i>;
        }

        if (item.eventSummary.schoolRolloverForm == undefined) {
            return <i className="cell-content-row">No form data</i>;
        }

        return <Fragment>
            <div className={"flex-row cell-content-row"}>
                <div className={"flex-column flex-item--flex-1"}>
                    Rollover:
                </div>
                <div className={"flex-column flex-item--flex-1"}>
                    <TimeTrafficCellContent date={item.eventSummary.schoolRolloverForm.rolloverDate} enableColour={!schoolRollover.isRolledOver} amberOffset={0} redOffset={1} />
                </div>
            </div>
            <div className={"flex-row cell-content-row"}>
                <div className={"flex-column flex-item--flex-1"}>
                    Students Memberships:
                </div>
                <div className={"flex-column flex-item--flex-1"}>
                    <TimeTrafficCellContent date={item.eventSummary.schoolRolloverForm.addStudentMembershipsDate} enableColour={schoolRollover.areStudentsEnabled === false} amberOffset={0} />
                </div>
            </div>
        </Fragment>
    }

    private async startDisconnect(schoolCode: string) {
        try {
            await this.props.apiService.startRolloverDisconnectForSchool(this.props.tenantId, schoolCode);
            this.props.dispatch(Actions.showMessageBar(`Started disconnect workload`, MessageBarType.success));
            await this.loadRolloverState();
            await this.loadSchoolRolloverEvents();
        }
        catch (e) {
            this.props.dispatch(Actions.showMessageBar(`Error starting disconnect workload: ${e.message}`, MessageBarType.error));
        }
    }

    private async startArchive(schoolCode: string) {
        try {
            await this.props.apiService.startRolloverArchiveForSchool(this.props.tenantId, schoolCode);
            this.props.dispatch(Actions.showMessageBar(`Started archive workload`, MessageBarType.success));
            await this.loadRolloverState();
            await this.loadSchoolRolloverEvents();
        }
        catch (e) {
            this.props.dispatch(Actions.showMessageBar(`Error starting archive workload: ${e.message}`, MessageBarType.error));
        }
    }

    private readyCheckbox(schoolCode: string, isDisconnected: boolean, isReady: boolean) {
        return (
            <Checkbox disabled={!isDisconnected} checked={isReady} onChange={async (e, checked) => {
                if (checked) {
                    try {
                        await this.props.apiService.rolloverReadySchool(this.props.tenantId, schoolCode);
                        this.props.dispatch(Actions.showMessageBar(`Set school ready`, MessageBarType.success));
                        await this.loadRolloverState();
                        await this.loadSchoolRolloverEvents();
                    }
                    catch (e) {
                        this.props.dispatch(Actions.showMessageBar(`Error readying school: ${e.message}`, MessageBarType.error));
                    }
                }
                else {
                    try {
                        await this.props.apiService.rolloverUnreadySchool(this.props.tenantId, schoolCode);
                        this.props.dispatch(Actions.showMessageBar(`Set school unready`, MessageBarType.success));
                        await this.loadRolloverState();
                        await this.loadSchoolRolloverEvents();
                    }
                    catch (e) {
                        this.props.dispatch(Actions.showMessageBar(`Error unreadying school: ${e.message}`, MessageBarType.error));
                    }
                }
            }} />);

    }

    private workloadCell(name: string, workloadId: string, workloadStatus: string, startDisabled: boolean, startWorkload: () => any) {
        const startWorkloadButton = (<PrimaryButton disabled={startDisabled} text={`Start ${name} Workload`} onClick={async () => await startWorkload()} />)

        if (workloadId != null) { // Check if workload has run
            switch (workloadStatus) {
                case "Completed":
                case "Running":
                case "Pending":
                    return <DurableFunctionInstanceStatus status={workloadStatus}></DurableFunctionInstanceStatus>
                default:
                    return <Fragment>
                        <DurableFunctionInstanceStatus status={workloadStatus}></DurableFunctionInstanceStatus>
                        {startWorkloadButton}
                    </Fragment>
            }
        }
        else {
            return <Fragment>
                {startWorkloadButton}
            </Fragment>;
        }
    }

    private async approveUpdateRollover(tenantId: string, schoolCode: string) {
        try {
            this.setState({ approveUpdateLoading: true });
            await this.props.apiService.rolloverApproveUpdate(this.props.tenantId, schoolCode);
            this.props.dispatch(Actions.showMessageBar(`Approved and updated configs`, MessageBarType.success));
            this.setState({ approveUpdateLoading: false });
            await this.loadRolloverState();
            await this.loadSchoolRolloverEvents();
        }
        catch (e) {
            this.props.dispatch(Actions.showMessageBar(`Error(s): ${e.message}`, MessageBarType.error));
            this.setState({ approveUpdateLoading: false });
        }
    }

    private async startUpload(tenantId: string, schoolCode: string) {
        try {
            this.setState({ startUploadLoading: true });
            await this.props.apiService.rolloverStartUpload(this.props.tenantId, schoolCode);
            this.props.dispatch(Actions.showMessageBar(`Started an Automation Upload`, MessageBarType.success));
            this.setState({ startUploadLoading: false });
            await this.loadRolloverState();
            await this.loadSchoolRolloverEvents();
        }
        catch (e) {
            this.props.dispatch(Actions.showMessageBar(`Error(s): ${e.message}`, MessageBarType.error));
            this.setState({ startUploadLoading: false });
        }
    }

    private async previewProcessor(item: SchoolRolloverState) {

        try {
            const rolloverProcessorOverrides: Partial<MailroomSchoolConfig> = {
                academicYear: TARGET_ROLLOVER_YEAR
            }

            var processorInstance = await this.props.apiService.triggerMailroomProcessor(this.props.tenantId, item.schoolCode, rolloverProcessorOverrides);

            this.props.dispatch(Actions.showMessageBar(`Started Processor Preview for ${item.schoolCode}`, MessageBarType.success));

            window.open(`/cdb-admin/mailroom/salamander/${this.props.tenantId}/${item.schoolCode}/process/${processorInstance.id}`, "_blank");
        }
        catch (e) {
            console.log(e);
            this.props.dispatch(Actions.showMessageBar(`Failed to start processor ${e}`, MessageBarType.error));
        }
    }

    private toggleStudentMembershipButton(item: SchoolRolloverState) {

        const schoolRollover = this.state.tenantRollover?.schools.find(sr => sr.schoolCode === item.schoolCode);
        if (schoolRollover == undefined) {
            return <div>Unknown Membership state</div>;
        }

        if (schoolRollover.areStudentsEnabled) {
            return <PrimaryButton text="Disable student memberships" disabled={this.state.loadingToggleStudentMemberships} onClick={async () => await this.toggleStudentMemberships(item)} />
        }
        else {
            return <PrimaryButton text="Enable student memberships" disabled={this.state.loadingToggleStudentMemberships} onClick={async () => await this.toggleStudentMemberships(item)} />
        }
    }

    private async toggleStudentMemberships(item: SchoolRolloverState) {
        try {
            this.setState({ loadingToggleStudentMemberships: true });
            await this.props.apiService.toggleStudentMembershipsForRollover(this.props.tenantId, item.schoolCode);
            this.setState({ loadingToggleStudentMemberships: false });
            await this.loadRollover();
            await this.loadRolloverState();
            await this.loadSchoolRolloverEvents();
        }
        catch (e) {
            console.log(e);
            this.props.dispatch(Actions.showMessageBar(`Failed to toggle student memberships ${e}`, MessageBarType.error));
            this.setState({ loadingToggleStudentMemberships: false });
        }
    }

    private tenantRender() {
        if (this.state.loadingTenantRollover) {
            return <LoadingCard />
        }
        else {
            return <div className="card">
                <div className="card__header">
                    <h2 className={"card__title"}>
                        {this.state.tenantRollover?.tenantName}
                    </h2>
                </div>
                <div className="card__content">
                    <div>
                        Allocated to: {this.state.tenantRollover?.allocatedToId /* TODO: component to load usernames that can also use cache? */}
                    </div>
                    {this.tenantStateRender()}
                </div>
            </div>
        }
    }

    private tenantStateRender() {
        if (this.state.loadingTenantRolloverState) {
            return <LoadingCard />
        }
        else {
            return <Fragment>
                <div>
                    Permissions Accepted: <BoolPill style={{ display: "inline-block" }} value={this.state.tenantRolloverState!.newSdsPermission} />
                </div>
                <div>
                    Has <strong>{PREVIOUS_ROLLOVER_PROFILE_NAME}</strong> Expired: <BoolPill style={{ display: "inline-block" }} value={this.state.tenantRolloverState!.hasPreviousYearsFlowExpired} />
                </div>
            </Fragment>
        }
    }

    private schoolStatesRender() {
        if (this.state.loadingTenantRolloverState) {
            return <LoadingCard />
        }
        else if (this.state.tenantRolloverState !== undefined) {
            return <Table
                title="School(s)"
                columns={TenantRolloverPage.schoolColumns}
                items={this.state.tenantRolloverState.schoolStates}
                cellForColumn={this.cellsForSchoolTable} />
        }
    }

    private schoolRolloverEventsRender() {
        if (this.state.loadingSchoolRolloverEvents) {
            return <LoadingCard />
        }
        else if (this.state.schoolRolloverEvents !== undefined) {
            return <Table
                title="School Event(s)"
                columns={TenantRolloverPage.schoolRolloverEventsColumns}
                items={this.state.schoolRolloverEvents}
                cellForColumn={this.cellsForSchoolRolloverEventTable} />
        }
    }

    render() {
        return (
            <Fragment>
                <PageTitle title={"Flow Rollover"} />
                {this.tenantRender()}
                {this.schoolStatesRender()}
                {this.schoolRolloverEventsRender()}
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: { match: any }): TenantRolloverPageProps => {

        const tenantId = ownProps.match.params.tenantId;

        return {
            apiService: state.auth.apiService,
            tenantId: tenantId,
            usersAccessLevel: state.auth.usersCdbAccessLevel
        };
    }
)(TenantRolloverPage)